var React = require('react');

function Checkbox (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0H42V42H0V0Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27.2222 14.7778V27.2222H14.7778V14.7778H27.2222ZM27.2222 13H14.7778C13.8 13 13 13.8 13 14.7778V27.2222C13 28.2 13.8 29 14.7778 29H27.2222C28.2 29 29 28.2 29 27.2222V14.7778C29 13.8 28.2 13 27.2222 13Z","fill":"#4C3371","key":1})]);
}

Checkbox.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Checkbox;

Checkbox.default = Checkbox;
